import { render, staticRenderFns } from "./editSmallWechat.vue?vue&type=template&id=7d487c62"
import script from "./editSmallWechat.vue?vue&type=script&lang=js"
export * from "./editSmallWechat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports